import { createFileRoute, Outlet } from '@tanstack/react-router'

// Recipe Generator POC: reachable by URL only (not in the nav or command palette).
export const Route = createFileRoute('/poc/recipe-generator')({
  component: Outlet
})
